"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        led: function (_a) {
            var color = _a.color, width = _a.width;
            return ({
                width: width ? "".concat(width, "px") : '8px',
                height: width ? "".concat(width, "px") : '8px',
                borderRadius: '50%',
                display: 'inline-block',
                marginRight: '12px',
                backgroundColor: color,
            });
        },
    });
});
